import type { RegenMode } from '../model/drivingPreferences';

export interface RegenOption {
  id: RegenMode;
  name: string;
  description: string;
  icon: string;
  /** 페달을 완전히 놓았을 때 목표 감속도(m/s²). */
  deceleration: number;
}

export const regenOptions: readonly RegenOption[] = [
  {
    id: 'standard',
    name: '표준',
    description: '자연스러운 타력 주행 · 약한 회생',
    icon: '▱',
    deceleration: 0.6,
  },
  {
    id: 'strong',
    name: '강',
    description: '페달을 놓으면 빠르게 감속',
    icon: '◫',
    deceleration: 1.25,
  },
  {
    id: 'one-pedal',
    name: '원페달',
    description: '강한 회생 · 저속 자동 정지 유지',
    icon: '▰',
    deceleration: 2.1,
  },
];

export function findRegenOptionById(id: RegenMode): RegenOption {
  return regenOptions.find((option) => option.id === id) ?? regenOptions[0];
}
